import { FunctionComponent } from "react";
import TopNav from "../../components/navigation/TopNav";
import MobileNav from "../../components/navigation/MobileNav";
import Contact from "../../components/website/Contact";
import Footer from "../../components/website/Footer";
import TrustedPartnersHeader from "../../components/website/TrustedPartners/TrustedPartnersHeader";
import TrustedPartnersContent from "../../components/website/TrustedPartners/TrustedPartnersContent";


const TrustedPartners: FunctionComponent = () => {
    return (
        <div className="max-w-[1440px] mx-auto w-full">
            <TopNav />
            <MobileNav />
            <TrustedPartnersHeader />
            <TrustedPartnersContent />
            <Contact />
            <Footer />
        </div>  
    );
};


export default TrustedPartners;




